import { render, staticRenderFns } from "./match-details-table-legend.vue?vue&type=template&id=68fbc827&"
import script from "./match-details-table-legend.vue?vue&type=script&lang=ts&"
export * from "./match-details-table-legend.vue?vue&type=script&lang=ts&"
import style0 from "./match-details-table-legend.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports